import { createSlice } from '@reduxjs/toolkit';

export const userManagementSlices = createSlice({
	name: 'userManagement',
	initialState: {},
	reducers: {
		// Get Permission Descriptions
		getPermissionDescriptions_request: (state) => {
			state.getPermissionDescriptions_requesting = true;
			state.getPermissionDescriptions_isSuccessful = undefined;
		},
		getPermissionDescriptions_success: (state, action) => {
			state.getPermissionDescriptions_requesting = false;
			state.getPermissionDescriptions_isSuccessful = true;
			
			state.permissionDescriptions = action.payload;
		},
		getPermissionDescriptions_failure: (state) => {
			state.getPermissionDescriptions_requesting = false;
			state.getPermissionDescriptions_isSuccessful = false;
		},
	},
});

export const { 
	getPermissionDescriptions_request, getPermissionDescriptions_success, getPermissionDescriptions_failure,
} = userManagementSlices.actions;

export default userManagementSlices.reducer;